<template>
  <!-- TODO:restore [min-width: 1350px;] -->
  <div
    id="contentWrapper-container"
    class="full flex-row"
    style=" min-width: 1350px"
  >
    <div class="sec--menu" :class="{ 'logo-collapsed': isCollapse }">
      <!-- todo:添加Log0 !-->
      <div class="sec-menu__img">
        <div class="logo">
          <svg-icon
                icon="deepcat-logo-head"
                style="font-size: 200px; vertical-align: text-bottom"
                v-if="!isCollapse"
              >
          </svg-icon>
          <svg-icon
            icon="deepcat-logo"
            style="font-size: 30px; vertical-align: text-bottom"
            v-if="isCollapse"
          >
          </svg-icon>   
          <!-- <img src="@/static/images/logo-left.png" alt="DeepCAT Logo" class="logo-left-img">
          <span class="main-title-text" v-if="!isCollapse">DeepCAT</span> -->
        </div>
      </div>
      <el-scrollbar
        class="menu__wrapper"
        style="
          box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%),
            0 4px 25px 0 rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
        "
      >
        <custome-menu
          class="menu__out-wrapper"
          :menus="getLeftMenu"
          :routeRender="renderMenuRoute"
        ></custome-menu>
      </el-scrollbar>
    </div>
    <div class="sec--right full flex-col">
      <HeaderPart :is-show-menu="!isShowMenu" :is-show-logo="isShowLogo" ></HeaderPart>

      <!-- 页面容器 -->
      <div
        id="innerContent-container"
        class="container body-content flex-col flex-expend"
        style="overflow-y: auto; overflow-x: hidden"
      >
        <div
          :class="['bar__route-map', '', routeMapClass]"
          :style="routeMapStyle"
          v-if="!isMainPage && !isShowMenu"
        >
          <div class="bar__route-map--source inline-block">
            <el-breadcrumb>
              <svg-icon class="mr-6" icon="home"></svg-icon>
              <el-breadcrumb-item v-for="item in parts" :key="item">
                <span class="no-redirect">{{ item }}</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <router-view class="page-container" :key="$route.fullPath"></router-view>
      </div>
      <!-- foot -->
      <FootPart v-if="isMainPage"></FootPart>
    </div>
  </div>
</template>

<script>
import HeaderPart from "./components/Header";
import FootPart from "./components/Foot";
import config from "@/configs/pathConfigures";
import { mapGetters } from "vuex";
import customeMenu from "../../components/customeMenu.vue";

export default {
  components: {
    HeaderPart,
    FootPart,
    customeMenu,
  },
  props: {
    routeMapClass: String,
    routeMapStyle: String,
  },
  data() {
    return {
      leftMenuPackName: "cat_left_menu_pack",
      isShowLogo:false,
    };
  },
 
  computed: {
    ...mapGetters(["customeRoadMap", "getLeftMenu"]),
    isCollapse(){
      return this.$store.getters.getIsCollapse;
    },
    isShowMenu() {
      let showMenu = false;
      let browsePath = config.prefixUrl + "/book/browse/:id";
      this.$route.matched.$$each((match) => {
        if (match.path === browsePath) {
          showMenu = true;
        }
      });
      return showMenu;
    },
    isMainPage() {
      return this.$route.matched.$$all((match) => {
        return [config.prefixUrl, config.prefixUrl + "/home"].$$any(
          (path) => path == match.path
        );
      });
    },
    parts() {
      if (this.customeRoadMap) {
        return this.customeRoadMap;
      } else {
        let result = [
          ...this.$route.matched
            .filter((item) => item)
            .$$select((r) => r.meta.title)
            .filter((item) => item),
        ].$$flat();

        if (result.length < 1 || result[0] != "首页") {
          result = [ ...result];
        }
        return result;
      }
    },
  },
  methods: {
    renderMenuRoute(url) {
      return { path: url };
      const query = this.$route.query;
      return {
        path: url,
        query,
      };
    },
   
  },
  created() {
    this.$store.dispatch("switchLeftMenu", this.leftMenuPackName);
  },
  mounted() {},
};
</script>

<style lang="scss">
#contentWrapper-container {
  background-color: rgb(228, 227, 239);
  
  .sec--menu{
    width: 15rem;
    -ms-flex-negative: 0;
    height: 100%;
    overflow: auto;
    background: linear-gradient(to bottom, rgb(89, 101, 249) 0%, #764ba2 100%);
    font-family: Montserrat, sans-serif;

    .sec-menu__img{
      height: 4.375rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 10px;
      background: rgb(89, 101, 249);
      border-block-end: 1px solid rgba(255, 255, 255, 0.15);

      .logo{
        display: flex;
        align-items: center;
        color: white;

        .main-title-text{
          font-size: 25px;
          font-weight: 600;
          margin-left: 10px
        }
      }
    }
  }
  .logo-collapsed {
    width: 80px; 
  }
  .sec--right{
    width: calc(100% - 240px);
    height: 100%;
    flex: 1;
  }

  .menu__out-wrapper {
    flex-shrink: 0;
    z-index: 3;
    position: relative;
  }
}

#innerContent-container {
  padding: 0px 20px 20px 20px;
  position: relative;
  .page-container {
    border: 1px solid #ebebeb;
    border-radius: 3px;
    transition: 0.2s;
    background-color: white;
    padding: 12px;
  }

  .page-container__paddingless {
    padding: 0;
  }

  .bar__route-map {
    color: #666666;
    display: flex;
    align-items: center;
    height: 50px;
    position: static;

    > * {
      vertical-align: middle;
    }

    .bar__route-map--source {
      .el-breadcrumb {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
      }
      .el-breadcrumb__item {
        position: absolute;
        display: contents;
      }
    }
  }
}
</style>
